import React, {useEffect, useState} from "react";
import ApiService from "../ApiService";
import MessageDetail from "./MessageDetail";
import { Row, Spinner, Card, Table, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import moment from "moment";
import { BsArrowLeft } from "react-icons/bs";

const SentMessageOthers = (props) => {
    const [messages, setmessages] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mode, setMode] = useState(null);
    const [messageUUID, setMessageUUID] = useState(null);
    const [goBack, setGoBack] = useState(false);

    useEffect(() => {
        setLoading(true);
        async function getMessageSent() {
            try {
                const getMessageSent = await ApiService.getMessageSentOthers();
                setLoading(false);
                setmessages(getMessageSent.data);
            } catch(ex) {
                console.error(ex);
            }
        }
        getMessageSent();
    }, []);

    useEffect(() => {
        if(props.goBack !== goBack) {
            setMode(null)
            setGoBack(!goBack)
        }
    }, [props.goBack])

    function fetchMessage(messageUUID) {
        setMode('VIEW_MESSAGE_DETAIL');
        setMessageUUID(messageUUID);
    }

    function renderTableData() {
        if (messages) {
            return messages.map((result, index) => {
                const {messageUUID, from, subject, to, createdDateTime, patientDob, ccOnly, state} = result;
                if (messages[index].unread) {
                    return (
                        <tr className="TableRow" key={messageUUID} onClick={() => fetchMessage(messageUUID)}>
                            <td className="TableTd unRead" key={messageUUID}>To: {from}</td>
                            <td className="TableTd unRead" key={messageUUID}>{messageUUID}</td>
                            <td className="TableTd unRead" key={messageUUID}>
                                {moment(createdDateTime).format("ddd MMM D, YYYY LT")}
                            </td>
                            <td className="TableTd unRead" key={messageUUID}>{patientDob}</td>
                            <td className="TableTd unRead" key={messageUUID}>{state}</td>
                            <td className="TableTd unRead" key={messageUUID}>{to === null ? <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                    <Tooltip>
                                        <Row className="tooltipCard">
                                            This message is visible to clinicians@tbd.health
                                        </Row>
                                    </Tooltip>
                                    }
                                >
                                    <Button size="sm" id="clearBtn">All</Button>
                                </OverlayTrigger> : to}</td>
                        </tr>
                    )
                } else {
                    return (
                        <tr className="TableRow" key={messageUUID} onClick={() => fetchMessage(messageUUID)}>
                            <td className="TableTd" key={messageUUID}>To: {from}</td>
                            <td className="TableTd" key={messageUUID}>{subject}</td>
                            <td className="TableTd" key={messageUUID}>
                                {moment(createdDateTime).format("ddd MMM D, YYYY LT")}
                            </td>
                            <td className="TableTd" key={messageUUID}>{patientDob}</td>
                            <td className="TableTd" key={messageUUID}>{state}</td>
                            <td className="TableTd" key={messageUUID}>{to === null ? <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                    <Tooltip>
                                        <Row className="tooltipCard">
                                            This message is visible to clinicians@tbd.health
                                        </Row>
                                    </Tooltip>
                                    }
                                >
                                    <Button size="sm" id="clearBtn">All</Button>
                                </OverlayTrigger> : to}
                            </td>
                        </tr>
                    )
                }
            })
        }
    }

    if (loading) {
        return (
            <Row>
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </Row>
        )
    } else if (!loading && mode !== 'VIEW_MESSAGE_DETAIL') {
        return (
            <Card body className="CardFullBody">
                <Table borderless>
                    <tr className="TableHeaderRow">
                            <td className="HeaderTd">Sender</td>
                            <td className="HeaderTd">Subject</td>
                            <td className="HeaderTd">Date/Time</td>
                            <td className="HeaderTd">Dob</td>
                            <td className="HeaderTd">State</td>
                            <td className="HeaderTd">Recipients</td>
                    </tr>
                    {renderTableData()}
                </Table>
            </Card>
        )
    } else if (mode === 'VIEW_MESSAGE_DETAIL') {
        return (
            <Card body className="CardFullBody">
                <Card.Body className="messageDetailBody">
                    <span className="go-back-wrap" onClick={() => setMode(null)}>
                        <BsArrowLeft />
                    </span>
                <MessageDetail messageUUID={messageUUID} sentMessage={true}/>
                </Card.Body>
            </Card>
        )
    }
}
export default SentMessageOthers;